import React, { FC } from 'react';
import { Typography } from '@mui/material';
import Search from '../../components/search-bar';
import useStyles from './styles';

const Home: FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.pageContainer}>
      <Typography variant="h1" className={classes.siteTitle}>
        TELEMATICS GATEWAY
      </Typography>
      <Search page="transactions" />
    </div>
  );
};

export default Home;
